import { Box, Button, Group, Modal, Text, TextInput, Textarea } from '@mantine/core'
import { useForm } from '@mantine/form'
import { Tradeshow } from 'api/dto/tradeshow'
import { Visitor } from 'api/dto/visitor'
import { useDeleteVisitor } from 'api/query/visitor'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

interface DeleteVisitorProps {
  opened: boolean
  onClose: () => void
  visitor?: Visitor
}

export function DeleteVisitor({ visitor, opened, onClose }: DeleteVisitorProps) {
  const { t } = useTranslation()
  const { tradeshowId } = useParams()
  const form = useForm<Tradeshow>({})
  const { mutateAsync: deleteVisitor } = useDeleteVisitor(tradeshowId!)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!opened) {
      form.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened])

  async function onSubmit() {
    if (!visitor?.id) {
      return
    }

    setSubmitting(true)
    await deleteVisitor(visitor.id)
    setSubmitting(false)
    onClose()
  }

  return (
    <Modal size="lg" opened={opened} onClose={onClose} title={t('visitor.delete')}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Text size="15px">{t('visitor.delete-visitor', { replace: { name: visitor?.fullName } })}</Text>

        <Group mt={30} position="right">
          <Button disabled={submitting} variant="outline" size="xs" color="red" onClick={onClose}>
            {t('common.cancel')}
          </Button>

          <Button loading={submitting} disabled={submitting || !form.isValid()} size="xs" variant="outline" color="green" type="submit">
            {t('common.delete')}
          </Button>
        </Group>
      </form>
    </Modal>
  )
}
